import React from 'react';
import { HeartIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { PriceBlock } from '../PriceBlock';
import { OFFER_SECTION_ID } from '../../data/salesContent';
export function OfferSection() {
  return <section id={OFFER_SECTION_ID} className="scroll-mt-4 bg-sage-soft px-5 py-20 md:py-28" aria-labelledby="offer-title" data-id="element-158" data-mp="fgl7yiatxfbn">
      <div className="mx-auto max-w-3xl overflow-hidden rounded-3xl border border-line bg-white shadow-xl shadow-ink/5" data-id="element-159" data-mp="akw7mcqzjuea">
        <div className="border-b border-line bg-rose-soft px-6 py-10 text-center md:px-12" data-id="element-160" data-mp="1qhvuk5nz1zx">
          <HeartIcon className="mx-auto h-7 w-7 fill-rose text-rose" aria-hidden="true" data-id="element-161" data-mp="1ona53mkj5us" />
          <h2 id="offer-title" className="mt-4 font-serif text-3xl uppercase leading-[1.15] text-ink md:text-4xl" data-id="element-162" data-mp="3sug93mi8iy6a">
            Todo un sistema práctico <span className="text-rose-dark" data-id="element-163" data-mp="3iyv0h5inuznk">para una etapa llena de cambios.</span>
          </h2>
          <p className="mt-4 text-base font-bold uppercase tracking-[0.15em] text-honey-dark md:text-lg" data-id="element-164" data-mp="3ewrngcgcfn06">5 volúmenes + 4 bonos</p>
        </div>
        <div className="px-6 py-10 text-center md:px-12" data-id="element-165" data-mp="1aqpks7eugjay">
          <PriceBlock lead="Hoy por" data-id="element-166" data-mp="1fj0hz2i79qzt" />
          <div className="mt-8" data-id="element-167" data-mp="1fk1wxi2c6xmt">
            <CtaButton note="Guías ilustradas, información organizada y herramientas prácticas para consultar desde casa." data-id="element-168" data-mp="10u4dtgj9ky4h">
              Quiero acceder al kit completo
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}